import { PageRequest } from '@/components/table/types/PageRequest.ts';
import { FilterCriteriaDto } from '@/components/table/types/FilterCriteriaDto.tsx';
import { PagedDto } from '@/components/table/types/PagedDto.ts';
import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import { TableDefinitionDto } from '@/components/table/types/TableDefinitionDto.ts';
import { ParticipantDto } from '@/features/dashboard/participants/types/ParticipantDto.ts';
import { buildPageRequestParams } from '@/components/table/types/TableUtil.ts';

const tourParticipantsApi = {
  getParticipants: async (
    tourId: string,
    pageRequest: PageRequest,
    filterCriteria: FilterCriteriaDto,
  ): Promise<PagedDto<ParticipantDto>> => {
    const params = buildPageRequestParams(pageRequest);

    return await fetchPrivateApi<PagedDto<ParticipantDto>>(
      'POST',
      `tours/${tourId}/participants/all?${params.toString()}`,
      filterCriteria,
    );
  },
  getTableDef: async (tourId: string): Promise<TableDefinitionDto> => {
    return await fetchPrivateApi<TableDefinitionDto>(
      'GET',
      `tours/${tourId}/participants/table-definition`,
    );
  },
};

export default tourParticipantsApi;
